import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { cloneData, DataModel, DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../dto/dto.js';
import { LegacyOrderHook } from '../legacy-order-hook.js';
import { OrderSideEffectType } from './order-side-effect-type.js';
import { OrderSideEffect } from './order-side-effect.js';
import { OutboundWebhookProtocol } from './outbound-webhook-protocol.js';

export class OutboundWebhookSideEffect extends OrderSideEffect {
  static readonly TYPE_ID: string = 'eb22829474e74e3dace2ffce61ad7bf7';

  public readonly effectType: OrderSideEffectType = OrderSideEffectType.OutboundWebhook;

  private constructor(
    public readonly protocol: OutboundWebhookProtocol,
  ) {
    super();
  }

  get $typeId(): string {
    return OutboundWebhookSideEffect.TYPE_ID;
  }

  static create({ protocol }: { protocol: OutboundWebhookProtocol }): OutboundWebhookSideEffect {
    return new OutboundWebhookSideEffect(protocol);
  }

  static fromMap(context: SerializationContext, map: SerializedData): OutboundWebhookSideEffect {
    return new OutboundWebhookSideEffect(
        context.fromData(MapUtils.getRecord(map, 'protocol')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'effectType': fromEnumAsString(this.effectType),
      'protocol': context.toData(this.protocol),
    };
  }

  clone(): this {
    return new OutboundWebhookSideEffect(
        cloneData(this.protocol),
    ) as this;
  }

  isSame(other: OutboundWebhookSideEffect): boolean {
    if(this === other) {
      return true;
    }

    return other.effectType === this.effectType &&
      isSameData(other.protocol, this.protocol);
  }

  toLegacyOrderHook(): LegacyOrderHook | null {
    return null;
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof OutboundWebhookSideEffect;
  }

  static assertType(order: DataModel): order is OutboundWebhookSideEffect {
    return order instanceof OutboundWebhookSideEffect;
  }
}

export class OutboundWebhookSideEffectBuilder extends DataModelBuilder<OutboundWebhookSideEffect> {
  build(context: SerializationContext, map: SerializedData): OutboundWebhookSideEffect {
    return OutboundWebhookSideEffect.fromMap(context, map);
  }
}
